const server = process.env.REACT_APP_SERVER;

async function loginUsuario(info){
    var respuesta=await fetch(`${server}/sqlComun/empleados/login`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            usuario:info.usuario,
            password:info.password,
            idModulo:info.idModulo,
            regional:info.regional
        })
    })
    return respuesta.json()
}

export default {loginUsuario}